import AnimationAppear from './animations/AnimationAppear';

export default new class Animations {
    init() {
		this.initAnimations();
	}

    initAnimations() {
		  new AnimationAppear('.animation__appear');
    }
}